import clsx from 'clsx'
import { css } from '@emotion/css'
import { IconTrash } from '@tabler/icons'
import Confirm from '../../confirm'

const LogicItem = ({ data, active, onClick, onDelete }) => {
  const toDelete = (close) => {
    onDelete(data)
    close()
  }

  return (
    <div
      className={clsx(
        'flex items-center gap-4',
        css`
          &:hover {
            .invisible {
              visibility: visible;
            }
            .logic-box {
              border-color: #ed7b2f;
            }
          }
        `,
        active &&
          css`
            .logic-box {
              border-color: #ed7b2f;
              background: #fef3e6;
            }
          `
      )}
      onClick={() => onClick(data)}
    >
      <div className="logic-box flex-1 overflow-hidden overflow-ellipsis p-3 border border-dashed whitespace-nowrap cursor-pointer">
        {data.name}
      </div>
      <Confirm onConfirm={toDelete} title="删除后不可恢复，是否确定删除？">
        <div className="flex items-center gap-1 cursor-pointer text-primary-500 invisible w-[200px]">
          <IconTrash />
          <span>删除</span>
        </div>
      </Confirm>
    </div>
  )
}

const LogicList = ({ list, current, onSelect, onDelete }) => {
  return (
    <div className="flex flex-col border-r w-1/2">
      <div className="flex-1 flex flex-col gap-4 overflow-auto py-4">
        {list.map((item) => (
          <LogicItem
            key={item.id}
            data={item}
            active={current === item}
            onClick={onSelect}
            onDelete={onDelete}
          />
        ))}
      </div>
      <div className="h-12 flex items-center border-t">
        <span>{current ? `所选逻辑：${current.name}` : '新建逻辑'}</span>
      </div>
    </div>
  )
}

export default LogicList
